import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, catchError, map, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HotToastService } from '@ngxpert/hot-toast';
import * as Sentry from '@sentry/browser';

import { environment } from '@environments/environment';
import { GlobalsService } from './globals.service';

declare var Cookies: any;

@Injectable({
  providedIn: 'root',
})
export class CarInfoService {
  private http = inject(HttpClient);
  private translateService = inject(TranslateService);
  private hotToastService = inject(HotToastService);
  private globalsService = inject(GlobalsService);

  sendForm(aaaId: number, data: { name: string; email: string; phone: string; message: string; marketingAgree: boolean; ip: string }): Observable<any> {
    const aaaIdString: string = aaaId.toString();
    const unixTimestamp: number = Math.floor(Date.now());
    const randomNumber: number = Math.floor(Math.random() * (999 - 100 + 1) + 100); // 100 - 999
    const formUniqueId: string = unixTimestamp + '' + randomNumber + '010';
    const statsMonitorId = Cookies.get('_stats_of_visits');
    const exponeaEtc = Cookies.get('__exponea_etc__');
    const body = {
      aaaId: aaaIdString,
      branchId: 356,
      email: data.email,
      name: data.name,
      phone: data.phone,
      message: data.message,
      phoneCountryId: 44,
      marketingAgree: data.marketingAgree,
      personalAgree: true,
      webFormUrl: 'www.mototechna.cz',
      formUniqueId: formUniqueId,
      customerIP: data.ip,
      statsMonitorId: statsMonitorId ? statsMonitorId : undefined,
      exponeaEtc: exponeaEtc ? exponeaEtc : undefined,
    };

    return this.http.post<any>(`${environment.apiBeta74}/v1/forms/car-info/`, body, { headers: this.globalsService.headerHash() }).pipe(
      map((response: any) => {
        return response;
      }),
      this.hotToastService.observe({
        loading: this.translateService.instant('forms.hotToast.sendForm.loading'),
        success: this.translateService.instant('forms.hotToast.sendForm.success'),
        error: this.translateService.instant('forms.hotToast.sendForm.error'),
      }),
      catchError((e: any) => {
        const timestamp: number = new Date().getTime();
        Sentry.captureMessage('Nepodařilo se odeslat rezervační formulář - Timestamp: ' + timestamp + ' Error: ' + e.message, { level: 'fatal', extra: body });
        return of(e);
      }),
    );
  }

  getUserIp(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>('https://api.ipify.org/?format=json');
  }
}
